import { AlertStatesBaseCountersModel } from './alert-states-base-counters-model';
import { AlertStatesReasonCountersModel } from './alert-states-reason-counters-model';

export class AlertStatesAccessCountersModel extends AlertStatesBaseCountersModel {
  byReasons: AlertStatesReasonCountersModel[];
}
